import { render, staticRenderFns } from "./AddCourseTopic.vue?vue&type=template&id=c8ab6be4"
import script from "./AddCourseTopic.vue?vue&type=script&lang=js"
export * from "./AddCourseTopic.vue?vue&type=script&lang=js"
import style0 from "./AddCourseTopic.vue?vue&type=style&index=0&id=c8ab6be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports